import { render, staticRenderFns } from "./PersonLink.vue?vue&type=template&id=174a9090&"
import script from "./PersonLink.vue?vue&type=script&lang=js&"
export * from "./PersonLink.vue?vue&type=script&lang=js&"
import style0 from "./PersonLink.vue?vue&type=style&index=0&id=174a9090&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports